am.$(document).ready(function () {
    //The enchor/button/whatever is being clicked to open the modal will need:
    //class=openModal
    //content_type= the type of content for example if content comes from a tpl file, the content type is url
    //content = the content, for example if content type is tpl file, the content will be the name of the tpl file. 
    //title= the title of your modal that will appear on  in the dom
    am.$(document.body).on('click', '.openModal', function(){
        var contentType = this.attributes.content_type.nodeValue;
        var content = this.attributes.content.nodeValue;
        var title=this.title;
        var customClass = this.attributes.customClass ? this.attributes.customClass.value : null;
        var fadeout = this.attributes.requiresFadeOut ? this.attributes.requiresFadeOut : null;

        this.attributes.customWindow ? this.attributes.customWindow : null;
        this.attributes.customHeader ? this.attributes.customHeader : null;
        this.attributes.customTitle ? this.attributes.customTitle : null;
        buildModal(title, this.attributes.customWindow, this.attributes.customHeader, this.attributes.customTitle, customClass, fadeout );
        getContent(content, contentType);
        am.$("#page_wrapper_responsive").css("overflow", "hidden")
     })
    });

 function buildModal(title, customWindow, customHeader, customTitle, customClass, fadeout){
    am.$(".am-modalOverlay").remove()
    am.$(".am-modalWindow").remove()

    var modalOverlay = am.$("<div></div>").addClass("am-modalOverlay")
    if(customWindow != null){
        var modalWindow = am.$("<div></div>").addClass("am-modalWindow").addClass("am-modalWindow--"+customWindow.value+"");
    }else{
       var modalWindow = am.$("<div></div>").addClass("am-modalWindow");
    }
    if(customHeader != null){
        var modalHeader = am.$("<div></div>").addClass("am-modalHeader").addClass("am-modalHeader--"+customHeader.value+"");
    }else{
        var modalHeader = am.$("<div></div>").addClass("am-modalHeader");
    }
    if(customTitle != null){
        var modalTitle = am.$("<h1></h1>").addClass("am-modalTitle").addClass("am-modalTitle--"+customTitle.value+"").text(title);
    }else{
        var modalTitle = am.$("<h1></h1>").addClass("am-modalTitle").text(title)
    }
    if(customClass)
        modalWindow.addClass('am-modalWindow--'+customClass);

    var modalFrame = am.$("<div></div>").addClass("am-modalFrame")
    var modalCloseLink = am.$("<a></a>").addClass("am-modalCloseLink")
    var closeIcon=am.$("<span></span>").addClass("fal fa-times").attr("onclick", "closeModal()")
    var modalContent = am.$("<div></div>").addClass("am-modalContent")
    var element = am.$('body')[0];
    am.$(element).append(modalOverlay)
    am.$(element).append(modalWindow)
    am.$(".am-modalWindow").append(modalFrame)
    am.$(".am-modalFrame").append(modalHeader,modalContent)
    am.$(".am-modalHeader").append(modalTitle, modalCloseLink)
    am.$(".am-modalCloseLink").append(closeIcon)
    if(fadeout)
        modalWindow.append(am.$('<div class="am-fadeout"></div>'));
 }

 function closeModal(){
        am.$(".am-modalOverlay").remove()
        am.$(".am-modalWindow").remove()
        am.$("#page_wrapper_responsive").css("overflow", "auto")
 }
 
 function getContent(content, contentType){
    if(contentType  === 'url') {
        am.$(".am-modalContent").load(content, function(){
            am.$(".am-modalWindow").fadeIn()
        })
    }
 }

